<template>
    <div class="otp-dialog">
      <div class="otp-dialog-overlay"></div>
      <div class="otp-dialog-content">
        <p v-if="!isRegistered && qrCode" class="label">Please scan the below QR using Google Authenticator Application</p>
        <img v-if="!isRegistered && qrCode" class="qrCode" :src="qrCode" alt="qr"/>
        <div v-if="!isRegistered && qrCode" class="download" @click="downloadQr">
            Download QR code <img alt="download" src="../assets/download.svg" style="margin-left: 4px" />
            <span class="tooltiptext">Download to share it across your employees to get registered </span>
        </div>
        <p class="label">Please enter the One-Time Password (OTP) from your Google Authenticator app:</p>
        <input type="text" v-model="enteredOTP" placeholder="Enter OTP" />
        <button @click="onSubmit">Verify</button>
        <button v-if="downloadReport" @click="onCancel">Cancel</button>
        <div v-if="errorMessage" class="error">{{ errorMessage }}</div>
        <div v-if="otpError" class="error">{{ otpError }}</div>
      </div>
    </div>
</template>

<script>
import { downloadReport, getCookie, getDefaultReports } from "@/services/campaignService"
import { mapState } from "vuex";


export default ({
    name: 'TwoFaAuth',
    props: {
        qrCode: Object,
        errorMessage: String,
        downloadReport: Boolean,
        reportEntityId: String,
        advancedReport: Boolean,
        defaultReportsPayload: Object,
    },
    data() {
        return {
            enteredOTP: '',
            otpError: ''
        }
    },
    computed: {
      ...mapState(['reportData','reportEntityId']),
        isRegistered() {
            return getCookie('twoFactorRegistered') == 'true';
        }
    },
    methods: {
        async onSubmit() {
          if(!this.downloadReport) 
            this.$emit("verifyOtp", this.enteredOTP);
          else {
            if(!this.enteredOTP){
              this.otpError = 'Enter a valid otp'
              setTimeout(() => {
                this.otpError = ''
              }, 1000)
            } else {
                if(this.defaultReportsPayload) {
                  const response = await getDefaultReports(this.defaultReportsPayload, this.enteredOTP);
                  if(response.ok) {
                    this.$emit('cancel');
                    this.otpError = '';
                    response.json()
                      .then(data => {
                          data?.signedURLs?.map(url => {
                              window.open(url);
                          })
                      })
                  } else {
                      this.otpError = 'OTP verification failed'
                  }
                } else {
                  let reportEntityIdFromSavedReports = this.reportData?.reportEntityId;
                  let id = reportEntityIdFromSavedReports ? reportEntityIdFromSavedReports : !this.advancedReport && this.reportEntityId ? this.reportEntityId : this.reportEntityId;
                  
                  if(id) {
                    downloadReport(id, this.enteredOTP)
                      .then(res=>{
                          if(res.status != 200){
                              this.otpError = 'OTP verification failed'
                          }else{
                              this.$emit('cancel');
                              this.otpError = '';
                              return res.json()
                          }
                      })
                      .then(data => {
                          data?.signed_urls.map(url => {
                              window.open(url);
                          })
                      })
                  }
                }
            }
          }
        },
        downloadQr() {
            const link = document.createElement('a');
            link.href = this.qrCode;
            link.download = 'Register_QR.png';
            link.click();
        },
        onCancel() {
          this.$emit("cancel");
        }
    }
})
</script>

<style scoped>
 .otp-dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }
  
  .otp-dialog-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }
  
  .otp-dialog-content {
    width: 420px;
    position: relative;
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    text-align: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    z-index: 1;
  }
  
  .otp-dialog-content h2 {
    font-size: 24px;
    margin-bottom: 10px;
  }
  
  .otp-dialog-content p {
    font-size: 16px;
    margin-bottom: 20px;
    font-family: Inter-Regular;
    font-weight: 600;
    line-height: 17px;
    color: #666666;
    margin-top: 16px;
  }
  
  input[type="text"] {
    width: 180px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-right: 20px;
    margin-bottom: 20px;
  }
  
  button {
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    background-color: #007bff;
    color: #fff;
    cursor: pointer;
    font-size: 16px;
    margin-right: 10px;
  }
  
  button:hover {
    background-color: #0056b3;
  }
  
  button:focus {
    outline: none;
  }

  .resendOtp{
    text-align: end;
    color: #0004B5;
    font-size: 12px;
  }

  .content{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
  }

  .error{
    font-family: Inter-Regular;
    font-size: 12px;
    color: #EB5757;
    text-align: left;
    margin-left: 24px;
  }

  .inactive{
    opacity: 0.5;
  }

  .active{
    cursor: pointer;
  }
  .qrCode {
    width: 200px;
    height: 200px;
  }
  .download {
    background: #FFFFFF;
    box-shadow: 0px -4px 16px rgba(0, 0, 0, 0.08);
    font-family: 'Inter-Regular';
    font-weight: 700;
    font-size: 12px;
    color: #2E31BE;
    width: 152px;
    padding: 6px 12px;
    border: 1px solid #2E31BE;
    border-radius: 4px;
    margin: auto;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

    .download .tooltiptext {
        visibility: hidden;
        width: 152px;
        max-height: 53px;
        background-color: #383838;
        color: #fff;
        text-align: left;
        border-radius: 6px;
        padding: 5px 16px;
        position: absolute;
        z-index: 1;
        top: -5px;
        left: 105%;
        font-size: 10px;
        font-weight: 500;
        line-height: 12px;
        letter-spacing: 0px;

    }

    .download .tooltiptext::after {
        content: "";
        position: absolute;
        top: 12px;
        right: 100%;
        margin-top: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: transparent #383838 transparent transparent;
    }

    .download:hover .tooltiptext {
        visibility: visible;
    }
</style>